// Collapsible content
const toggleContainer = Array.from(
  document.getElementsByClassName('toggles-container')
);
const allToggles = document.getElementsByClassName('toggle');
const allContent = Array.from(document.getElementsByClassName('content'));

const displaySection = selectedToggle => {
  console.log(selectedToggle, 'selectedToggle')
  const toggleIsActive = selectedToggle.classList.contains('active');
  const expandableContent = selectedToggle.nextElementSibling;

  Array.from(allToggles).map(toggle => {
    toggle.className = toggle.className.replace(' active', '');
  });

  allContent.map(content => {
    content.style.maxHeight = null;
  });

  if (toggleIsActive) {
    selectedToggle.className = 'toggle';
  } else {
    selectedToggle.className += ' active';
    expandableContent.style.maxHeight = expandableContent.scrollHeight + 'px';
  }
};

toggleContainer.forEach(container => {
  container.addEventListener('click', e => {
    const selectedToggle = e.target;

    if (e.target.tagName === 'BUTTON') {
      displaySection(selectedToggle);
    }
  });
});
